import BaseService from "service/base.js";

class AccountStatsService {
  loadByDate(date) {
    return BaseService.get(`/api/account/stats/${date}`);
  }

  loadByAccount(accountId) {
    return BaseService.get(`/api/account/${accountId}/stats`);
  }
}

const accountStatsService = new AccountStatsService();

export { accountStatsService };
